import classNames from 'classnames'
import { t } from 'i18next'
import { ReactNode } from 'react'
import { PulseLoader } from 'react-spinners'

export interface IButtonSelectItem {
    mainText: string
    secondaryText: string
    value: string
    index: number
    name?: string
}

export interface IButtonSelect {
    baseColor?: string
    selectColor?: string
    className?: string
    size?: string
    textColor?: string
    textSize?: string
    secondaryTextSize?: string
    options: IButtonSelectItem[]
    prefix?: ReactNode
    postfix?: ReactNode
    onChange: (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        primary: string,
        secondary: string,
        id: number
    ) => void
    selected: string
    loadingSecondary?: boolean
}

const ButtonSelect: React.FC<IButtonSelect> = ({
    className,
    size,
    baseColor,
    selectColor,
    textColor,
    textSize,
    secondaryTextSize,
    options,
    onChange,
    selected,
    loadingSecondary,
}) => {
    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        primary: string,
        secondary: string,
        i: number
    ) => {
        onChange(e, primary, secondary, i)
    }

    return (
        <div className={classNames()}>
            <div className="lg:space-x-4 md:space-x-3 space-x-2 flex flex-row">
                {options.map((option, i) => (
                    <button
                        key={i}
                        type="button"
                        onClick={
                            loadingSecondary
                                ? () => { }
                                : (e) =>
                                    handleClick(
                                        e,
                                        option.mainText,
                                        option.secondaryText,
                                        option.index
                                    )
                        }
                        className={classNames(
                            'border-[1.5px] border-gray-400 shadow-md',
                            className,
                            textColor ? textColor : 'text-white',
                            textSize ? textSize : 'text-lg',
                            size ? size : 'h-16 w-32',
                            option.value === selected ? selectColor : baseColor
                        )}
                        value={option.value}
                        name={option.name}
                    >
                        <div className="flex flex-col ">
                            <div className="text-xl">{t(option.mainText)}</div>

                            <div
                                className={classNames(
                                    className,
                                    '-mt-0.5',
                                    secondaryTextSize
                                        ? secondaryTextSize
                                        : 'text-lg'
                                )}
                            >
                                {loadingSecondary &&
                                    option.name !== 'PlanDuration' ? (
                                    <PulseLoader size={12} />
                                ) : (
                                    <>{t(option.secondaryText)}</>
                                )}
                            </div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default ButtonSelect
